// Webpack Imports
import * as bootstrap from "bootstrap";

(function () {
  ("use strict");

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
    el.addEventListener("submit", function (e) {
      var search = el.querySelector("input");
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });
})();
// search bar toggle on
$(function () {
  $("#searchToggle").on("click", function () {
    // if search form has class hidden
    if ($("#searchForm").hasClass("hidden")) {
      $("#searchForm").removeClass("hidden");
      $(this).find("i").removeClass("fas fa-search");
      $(this).find("i").addClass("fas fa-times");
      $("#menu-top-menu").addClass("hidden");
    } else {
      $("#searchForm").addClass("hidden");
      $("#menu-top-menu").removeClass("hidden");
      $(this).find("i").removeClass("fas fa-times");
      $(this).find("i").addClass("fas fa-search");
    }
  });
});
$(function () {
  $(".file-list ul li").filter(function () {
    if ($(this).has("a").length) {
      $(this).addClass("listlink");
    }
    if ($(this).has("a").length == 0) {
      $(this).addClass("nolink");
    }
  });
});
